export default __webpack_public_path__ + "static/media/tileThrow.e119c508.mp3";